import { storage } from '@uhg-abyss/web/tools/storage';

// Direct method - just get the state
export const getStateFromSearchBar = (): string | undefined => {
  const location = storage.local.get('geoLocation') || {};
  return location.stateCode;
};
